import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { CreditosService } from "../../../services/creditos.service";

@Component({
    selector: 'estacionario-detalles',
    templateUrl: './estacionario-detalles.component.html',
    styleUrls: ['./estacionario-detalles.component.scss']
  })

export class EstacionarioDetallesComponent implements OnInit {
    errors:any = {};
  //Helpers
  private sub: any;
  public id: number = null;
  //UI vars
  public credito : any = { cliente : {}, prestamo : {}, sucursal : {} };
  public sectionStatus : any = {};
  public isEditable : boolean = false;
  public isInitialized : boolean = false;

  constructor(
    private route: ActivatedRoute,
    private creditosService: CreditosService,
    private helperService: HelpersService
    ){
   }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.id = +params['id'];// (+) converts string 'id' to a number
            this.getCredito(this.id);
            this.checkSectionsStatus();
            //Después de que cargan todos los elementos marco el componente como inicializado. 
            this.isInitialized = true;
        });
    }

    private getCredito(idCreditos : number){
        //TODO: Manejar cuando el id no retorna un crédito valido
        this.creditosService.get(idCreditos).subscribe(
            (response)=>
            {
            const credito = response.json().content;
            this.credito = credito;

            //Los créditos en estatus pendiente deben mostrarse en modo Editable
            if(credito.statusCredito === 1){
                this.isEditable = true;
            }
            
            }, error =>
            {
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);

                if(error.status == 400) {
                  this.helperService.setBackendErrors(error.json().content, this.errors);
                  this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
            }
        );
    }

    public checkSectionsStatus(){
        //Avisar a los demás componentes que hubo algún cambio en la información del crédito
        if(this.isInitialized){
            this.creditosService.reloadCreditoStatus();
        }
        
        this.creditosService.validateSections(this.id).subscribe(
            (response)=>
            {
            this.sectionStatus = response.json().content;    
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.showSaveCreditErrors(error.json().content, this.errors);
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/creditos/credigas-estacionario/detalles/estacionario-detalles.component.ts